import {
  ContentSuggest,
  AllContentResults,
  TopContentResult,
  Section,
} from '../../../../components/molecules/Form/components/ComboBox';

import { isNotNullOrUndefined, isNullOrUndefined } from '../../../../lib/typeGuards';

export default (t: (key: string) => string) =>
  (
    key: 'content' | 'pages' | 'filteredContent',
    containsAreaSearch: boolean,
    contentSuggestResponse?: ContentSuggest
  ): Section<TopContentResult | AllContentResults>[] => {
    if (isNullOrUndefined(contentSuggestResponse)) return [];

    const topResults: TopContentResult[] = contentSuggestResponse.topResults.map(r => ({
      ...r,
      type: 'topContentResult',
      // adding key to id to avoid duplicate ids in combination with duplicate results in filteredContentSearchResults
      id: `${r.id}-${key}`,
    }));
    const allResultsItem: AllContentResults | undefined =
      topResults.length > 0 && contentSuggestResponse.allUrl
        ? {
            id: `allContentResults`,
            type: 'allContentResult',
            pageLink: {
              url: contentSuggestResponse.allUrl.url,
              name: t(`${key}.resultsLabel`),
            },
          }
        : undefined;

    const combinedResults = [...topResults, allResultsItem].filter(isNotNullOrUndefined);
    return [
      {
        key,
        results: combinedResults,
        headline: !containsAreaSearch ? t(`${key}.headline`) : t(`${key}.headlineAreaSearch`),
      },
    ];
  };
